import { Loader2, Inbox, AlertTriangle } from "lucide-react";

export function Panel({ title, right, children, className = "" }) {
  return (
    <section className={`rounded-sm border border-border bg-[#0f0f0f] ${className}`}>
      {(title || right) && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-border">
          <h3 className="font-head font-bold tracking-tight text-sm uppercase tracking-wider">{title}</h3>
          {right}
        </div>
      )}
      <div>{children}</div>
    </section>
  );
}

export function PageTitle({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
      <div>
        <h1 className="font-head text-2xl md:text-3xl font-black tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}

export function Stat({ label, value, accent }) {
  return (
    <div className="rounded-sm border border-border bg-[#0f0f0f] p-4">
      <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className="mono text-2xl font-semibold mt-1" style={accent ? { color: accent } : {}}>{value}</div>
    </div>
  );
}

export function Loading({ testid = "loading" }) {
  return (
    <div data-testid={testid} className="flex items-center justify-center py-16 text-muted-foreground gap-2">
      <Loader2 className="h-5 w-5 animate-spin" /> Loading…
    </div>
  );
}

export function Empty({ label = "No data", testid = "empty-state" }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center py-16 text-muted-foreground">
      <Inbox className="h-8 w-8 mb-2" /> {label}
    </div>
  );
}

export function ErrorState({ error, onRetry, testid = "error-state" }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center py-16 text-muted-foreground">
      <AlertTriangle className="h-8 w-8 mb-2 text-[#EF4444]" />
      <div className="mb-3">{error || "Something went wrong"}</div>
      {onRetry && (
        <button onClick={onRetry} data-testid="retry-btn" className="rounded-sm border border-border px-3 py-1.5 text-sm hover:bg-[#1c1c1c] transition-colors">
          Retry
        </button>
      )}
    </div>
  );
}
